import moment from "moment/moment";
import React from "react";

export default function SymbolQtyCard({ item }) {
  return (
    <div className="flex flex-wrap md:flex-nowrap items-center justify-between bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl shadow-sm hover:shadow-md transition-all duration-200 p-3">
      {/* Symbol Name */}
      <div className="w-1/4 text-left text-[10px] font-medium text-[var(--text)] truncate">
        {item.symbol_display || "-"} { item.type === "nse_cash" ? "Equity" : moment(item.expiry_date).format("DD-MMM")}
      </div>

      {/* Total Qty */}
      <div className="w-1/6 text-center text-[10px] font-medium text-[var(--text)]">
        {item.min_qty ?? 0}
      </div>

      {/* Net Qty */}
      <div className={`w-1/6 text-center text-[10px] font-medium `}>
        {item.qty_per_order ?? 0}
      </div>

      {/* Min Qty */}
      <div className="w-1/6 text-center text-[10px] font-medium text-[var(--text)]">
        {item.total_quantity ?? 0}
      </div>

      {/* Date */}
      <div className="w-1/6 text-center text-[10px] text-[var(--text)]">
        {item.lot_size ?? 0}
      </div>
    </div>
  );
}
